module.exports = {
          srcSet: __webpack_public_path__ + "113a37066bbf9181f06aeb5ab3dba810-886.png"+" 886w",
          images:[ {path: __webpack_public_path__ + "113a37066bbf9181f06aeb5ab3dba810-886.png",width: 886,height: 390}],
          src: __webpack_public_path__ + "113a37066bbf9181f06aeb5ab3dba810-886.png",
          toString:function(){return __webpack_public_path__ + "113a37066bbf9181f06aeb5ab3dba810-886.png"},
          
          width: 886,
          height: 390
        }